import { render, staticRenderFns } from "./term-online-sale.vue?vue&type=template&id=66ad9874&"
import script from "./term-online-sale.vue?vue&type=script&lang=js&"
export * from "./term-online-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports